<template>
<div>
  <h1>Conductores Activos</h1>
  <b-row>
    <b-col md="6" class="my-1">
      <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
        <b-input-group>
          <b-form-input v-model="filter" class="form-control" placeholder="Buscar conductor"></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col md="6" class="my-1">
      <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
        <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
      </b-form-group>
    </b-col>
    <b-table
        show-empty
        stacked="md"
        :items="getActiveTaxiCheckIn"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        empty-text="No existen registros por mostrar"
        emptyFilteredText="No existen registros por mostrar"
      >
        <template v-slot:cell(actions)='row'>
          <b-button variant="success" size="md" @click="searchVehicle(row.item.id)" class="mr-2">
            Ver en mapa
          </b-button>
        </template>
      </b-table>

      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
  </b-row>
</div>
</template>
<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
import firebase from 'firebase'
const _ = require('lodash')
const GET_ALLOWED_DRIVERS = gql`
  query getConcesionDriverByConcesionarioId($concesionarioId: Int){
    getConcesionDriverByConcesionarioId(concesionarioId: $concesionarioId){
      driver{
        id
      }
    }
  }
`
export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        { key: 'id', label: 'Id' },
        { key: 'document.driver.firstName', label: 'Nombre(s)' },
        { key: 'document.driver.lastName', label: 'Apellidos' },
        { key: 'document.driver.license', label: 'Número de licencia' },
        { key: 'document.driver.cardId', label: 'Número de tarjetón' },
        { key: 'document.driver.email', label: 'Correo electrónico' },
        { key: 'document.driver.phoneNumber', label: 'Número de teléfono' },
        { key: 'document.vehicle.vehicleType.type', label: 'Tipo de vehículo' },
        { key: 'document.vehicle.licensePlate', label: 'Número de placa' },
        { key: 'document.vehicle.brand', label: 'Marca' },
        { key: 'document.vehicle.model', label: 'Modelo' },
        { key: 'actions', label: 'Acciones (Ver en mapa)' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      allowedDriversIds: {},
      getActiveTaxiCheckIn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      googleMapMarker: [],
      infoWindows: [],
      status: [],
      colors: {
        inactive: '#5D716E',
        available: '#29D336',
        unavailable: '#FF0000',
      },
      unsubscribe: null,
    }
  },
  apollo: {
    getConcesionDriverByConcesionarioId: {
      query: GET_ALLOWED_DRIVERS,
      context: headers(),
      variables() {
        return {
          concesionarioId: parseInt(this.$store.state.user.franchisee),
        }
      },
      result({ data }) {
        let allowedDrivers = []
        allowedDrivers = _.uniqWith(data.getConcesionDriverByConcesionarioId, _.isEqual)
        allowedDrivers.forEach(element => {
          this.allowedDriversIds[element.driver.id] = 1
        })
        console.log(this.allowedDriversIds)
        this.drawMarkers()
      },
      error(error) {
        console.log(error)
      },
    },
  },
  methods: {
    async drawMarkers() {
      this.getDrivers()
      const { Marker, LatLng, InfoWindow /* Size  */ } = this.google.maps
      const { docs } = await firebase
        .firestore()
        .collection('drivers')
        .where('active', '==', true)
        .get()
      docs.forEach(document => {
        if (this.allowedDriversIds[document.id] && document.data().location) {
          const driver = document.data()
          const id = driver.driver.id
          const location = driver.location
          const position = new LatLng(location.position.geopoint.latitude, location.position.geopoint.longitude)
          const color = driver.active ? (driver.onTrip ? this.colors.unavailable : this.colors.available) : this.colors.inactive
          const symbol = {
            path: 'M62.1,36.5c-0.9-1.2-3.6-1.5-3.6-1.5c0.1-3.5,0.5-6.9,0.7-8.2c1.9-7.3-1.7-11.8-1.7-11.8c-4.8-4.8-9.1-5-12.5-5   c-3.4,0-7.8,0.3-12.5,5c0,0-3.6,4.5-1.7,11.8c0.2,1.2,0.5,4.6,0.7,8.2c0,0-2.7,0.3-3.6,1.5c-0.9,1.2-0.9,1.9,0,1.9   c0.9,0,2.9-2.3,3.6-2.3V35c0,1,0.1,2,0.1,3c0,4.4,0,33.7,0,33.7s-0.3,6.1,5,7.8c1.2,0,4.6,0.4,8.4,0.5c3.8-0.1,7.3-0.5,8.4-0.5   c5.3-1.7,5-7.8,5-7.8s0-29.3,0-33.7c0-1,0-2,0.1-3v1.2c0.7,0,2.7,2.3,3.6,2.3C63,38.5,63,37.7,62.1,36.5z M34.7,66.5   c-0.3,3.3-2.3,4.1-2.3,4.1V37.4c0.8,1.2,2.3,6.8,2.3,6.8S34.9,63.2,34.7,66.5z M54.8,75.2c0,0-4.2,2.3-9.8,2.2   c-5.6,0.1-9.8-2.2-9.8-2.2v-2.8c4.9,2.2,9.8,2.2,9.8,2.2s4.9,0,9.8-2.2V75.2z M35.2,41.1l-1.7-10.2c0,0,4.5-3.2,11.5-3.2   s11.5,3.2,11.5,3.2l-1.7,10.2C51.4,39.2,38.6,39.2,35.2,41.1z M57.7,70.6c0,0-2.1-0.8-2.3-4.1c-0.3-3.3,0-22.4,0-22.4   s1.5-5.6,2.3-6.8V70.6z',
            fillColor: color,
            fillOpacity: 0.8,
            strokeColor: color,
            anchor: new this.google.maps.Point(45, 45),
            scale: 0.5,
            rotation: location.heading,
          }
          const marker = new Marker({
            position: position,
            marker: driver,
            map: this.map,
            icon: symbol,
            id: id,
          })
          this.googleMapMarker[id] = marker
          const infoWindow = new InfoWindow({
            disableAutoPan: true,
          })
          this.infoWindows[id] = infoWindow
          marker.addListener('click', () => {
            const content = `
                              <div class="ui header">Marca de vehículo: ${driver.vehicle.brand}</div>
                              <div class="ui header">Modelo de vehículo: ${driver.vehicle.model}</div>
                              <div class="ui header">Tipo de vehículo: ${driver.vehicle.vehicleType.type}</div>
                              <div class="ui header">Nombre de conductor: ${driver.driver.firstName}</div>
                              <div class="ui header">Apellido de conductor: ${driver.driver.lastName}</div>
                              `
            this.infoWindows[id].setContent(content)
            this.infoWindows[id].open(this.map, marker)
          })
        }
      })
      this.unsubscribe = firebase
        .firestore()
        .collection('drivers')
        .onSnapshot(snapshot => {
          if (snapshot.docChanges()[0].type === 'modified') {
            snapshot.docChanges().forEach(document => {
              const driver = document.doc.data()
              if (this.allowedDriversIds[driver.driver.id]) {
                console.log(driver.driver.id)
                const id = document.doc.id
                const location = driver.location
                const position = new LatLng(location.position.geopoint.latitude, location.position.geopoint.longitude)
                // const color = driver.active ? (driver.onTrip ? this.colors.unavailable : this.colors.available) : this.colors.inactive
                // this.googleMapMarker[id].icon.fillColor = color
                const color = driver.active ? (driver.onTrip ? this.colors.unavailable : this.colors.available) : this.colors.inactive
                const symbol = {
                  path: 'M62.1,36.5c-0.9-1.2-3.6-1.5-3.6-1.5c0.1-3.5,0.5-6.9,0.7-8.2c1.9-7.3-1.7-11.8-1.7-11.8c-4.8-4.8-9.1-5-12.5-5   c-3.4,0-7.8,0.3-12.5,5c0,0-3.6,4.5-1.7,11.8c0.2,1.2,0.5,4.6,0.7,8.2c0,0-2.7,0.3-3.6,1.5c-0.9,1.2-0.9,1.9,0,1.9   c0.9,0,2.9-2.3,3.6-2.3V35c0,1,0.1,2,0.1,3c0,4.4,0,33.7,0,33.7s-0.3,6.1,5,7.8c1.2,0,4.6,0.4,8.4,0.5c3.8-0.1,7.3-0.5,8.4-0.5   c5.3-1.7,5-7.8,5-7.8s0-29.3,0-33.7c0-1,0-2,0.1-3v1.2c0.7,0,2.7,2.3,3.6,2.3C63,38.5,63,37.7,62.1,36.5z M34.7,66.5   c-0.3,3.3-2.3,4.1-2.3,4.1V37.4c0.8,1.2,2.3,6.8,2.3,6.8S34.9,63.2,34.7,66.5z M54.8,75.2c0,0-4.2,2.3-9.8,2.2   c-5.6,0.1-9.8-2.2-9.8-2.2v-2.8c4.9,2.2,9.8,2.2,9.8,2.2s4.9,0,9.8-2.2V75.2z M35.2,41.1l-1.7-10.2c0,0,4.5-3.2,11.5-3.2   s11.5,3.2,11.5,3.2l-1.7,10.2C51.4,39.2,38.6,39.2,35.2,41.1z M57.7,70.6c0,0-2.1-0.8-2.3-4.1c-0.3-3.3,0-22.4,0-22.4   s1.5-5.6,2.3-6.8V70.6z',
                  // fillColor: '#FF0000',
                  fillColor: color,
                  fillOpacity: 0.8,
                  strokeColor: color,
                  anchor: new this.google.maps.Point(45, 45),
                  scale: 0.5,
                  rotation: location.heading,
                }
                this.googleMapMarker[id].setPosition(position)
                // this.googleMapMarker[id].icon.fillColor = color
                this.googleMapMarker[id].setIcon(symbol)
                // console.log(this.googleMapMarker[id])
              }
            })
          }
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getDrivers() {
      firebase.firestore().collection('drivers').where('active', '==', true).get()
        .then(drivers => {
          drivers.forEach(driver => {
            // console.log(driver.id)
            if (this.allowedDriversIds[driver.id]) {
              this.getActiveTaxiCheckIn.push({ id: driver.id, document: driver.data() })
            }
          })
          this.totalRows = this.getActiveTaxiCheckIn.length
          // console.log(this.getActiveTaxiCheckIn)
        })
        .catch(error => {
          console.log(error)
        })
    },
    searchVehicle(driverId) {
      if (this.googleMapMarker[driverId]) {
        // if ((!this.map.getBounds().contains(this.googleMapMarker[driverId].getPosition()))) {
        const marker = this.googleMapMarker[driverId]
        // this.map.event.trigger()
        this.map.panTo(marker.getPosition())
      // }
      }
    },
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  created() {
    // console.log(this.$store.state.user)
  },
  // eslint-disable-next-line vue/require-render-return
  render() {},
}
</script>
